import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip';
import { Size as IconSize } from '@jetbrains/ring-ui/components/icon/icon__constants';
import NavigationLink from '@app/common/navigation/navigation-link';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import HelpIcon from '../../common/util/help-icon';
import { useToolboxInfo } from '../../common/queries/toolbox';
import { ExternalLinks } from '../../common/constants/constants';
export function ToolboxAppLink({ className, tooltip = true }) {
    const serverConfig = useServerConfigContext();
    const offlineModeEnabled = serverConfig.isOfflineMode();
    const { data: toolboxInfo, isFetching } = useToolboxInfo();
    let toolboxVersionText;
    if (isFetching) {
        toolboxVersionText = 'Loading minimal toolbox version';
    }
    else if (toolboxInfo) {
        toolboxVersionText = `Minimal required version: ${toolboxInfo.minSupportedVersion}`;
    }
    else {
        toolboxVersionText = 'For the best experience install the latest version';
    }
    const tbaLink = offlineModeEnabled ? ('Toolbox App') : (_jsx(NavigationLink, { className: className, href: ExternalLinks.TOOLBOX_APP, children: "Toolbox App" }));
    return (_jsxs(_Fragment, { children: [tbaLink, !offlineModeEnabled && tooltip && (_jsxs(Tooltip, { title: toolboxVersionText, children: [' ', _jsx(HelpIcon, { size: IconSize.Size14 })] }))] }));
}
